import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/site/Bits";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = (next = "/account") => {
  const redirectUrl = window.location.origin + "/login?next=" + encodeURIComponent(next);
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const GoogleButton = ({ next }: { next?: string }) => (
  <button type="button" onClick={() => startGoogleLogin(next)} className="btn-ghost w-full" data-testid="google-login-button">
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
    Continue with Google
  </button>
);

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(loc.hash.slice(1)).get("session_id") || "";
    const next = new URLSearchParams(loc.search).get("next") || "/account";
    api.post("/auth/google/session", { session_id: sid }).then((r) => {
      setUser(r.data);
      const staff = ["owner", "admin", "staff"].includes(r.data.role);
      nav(next.startsWith("/admin") && !staff ? "/account" : staff && next === "/account" ? "/admin" : next, { replace: true });
    }).catch((e) => {
      toast.error(errMsg(e));
      setUser(false);
      nav("/login", { replace: true });
    });
  }, [loc, nav, setUser]);
  return <Spinner label="Signing you in" />;
};

export const GoogleGate = ({ children }: { children: React.ReactNode }) => {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;
  return <>{children}</>;
};
